import { isErrorResponse, ErrorResponse } from '../types/ErrorResponseTypes'
import ApiService from './apiService'
import http from '../http-common'
import { AxiosResponse, isAxiosError } from 'axios' // 👈 Import isAxiosError
import { isPermissionsReponseType, PermissionsResponse } from '@/types/permissions/PermissionsResponseType'

class IamService extends ApiService {
  /**
   * Fetches user permissions.
   * On success, returns a PermissionsReponseType.
   * On API error (like 403), returns an ErrorResponse.
   * Throws a generic Error for unexpected issues.
   */
  async getUserPermissions(): Promise<PermissionsResponse | ErrorResponse> {
    try {
      const params = { app_id: 'MY_CM_PORTAL' }
      // Await the response directly. If it fails, it will jump to the catch block.
      const response: AxiosResponse = await http.iam.get(`/user/permissions/portal`, { params })

      const parsedResponse = this.parseResponse(response)

      if (isPermissionsReponseType(parsedResponse)) {
        return parsedResponse
      }

      // If the successful response isn't the expected type, it's an error.
      throw new Error('Unexpected successful response type')
    } catch (error) {
      // Check if the error is an Axios error with a response (like a 403)
      if (isAxiosError(error) && error.response) {
        const parsedError = this.parseResponse(error.response)

        // If it can be parsed into your standard ErrorResponse, return it.
        if (isErrorResponse(parsedError)) {
          return parsedError
        }
      }

      // For any other kind of error, log it and re-throw it.
      console.error('An unexpected issue occurred in IamService:', error)
      throw new Error('Failed to fetch user permissions due to an unexpected error.')
    }
  }
}

export default new IamService()
